import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import {
  NavLink as RouterLink,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  List,
  Drawer,
  Link,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { AIconButton } from "src/components/@material-extend";
import { YellowLogo, BlackLogo } from "../../components/Logo.jsx";
import LogoImg from "src/assets/Images/logo-img.png";
import DarkBlueLogo from "src/assets/Images/logo-dark-blue.png";

import { PATH_DASHBOARD } from "src/routes/paths";

const ITEM_SIZE = 48;
const PADDING = 2.5;

const ListItemStyle = styled(ListItemButton)(({ theme }) => ({
  ...theme.typography.body2,
  height: ITEM_SIZE,
  textTransform: "capitalize",
  paddingLeft: theme.spacing(PADDING),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
}));

MenuMobileItem.propTypes = {
  item: PropTypes.object,
  isDark: PropTypes.bool,
  isActive: PropTypes.bool,
};

function MenuMobileItem({ item, isActive, isDark }) {
  const { title, path } = item;
  return (
    <ListItemStyle
      to={path}
      component={RouterLink}
      sx={{
        color: isDark ? "text.primary" : "text.secondary",
        ...(isActive && {
          color: "primary.main",
          fontWeight: 700,
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.selectedOpacity
            ),
        }),
      }}
    >
      <ListItemText disableTypography primary={title} />
    </ListItemStyle>
  );
}

MenuMobile.propTypes = {
  navConfig: PropTypes.array,
  isDark: PropTypes.bool,
};

export default function MenuMobile({ navConfig, isDark }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (mobileOpen) {
      handleDrawerClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleDrawerOpen = () => {
    setMobileOpen(true);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  return (
    <>
      <AIconButton
        onClick={handleDrawerOpen}
        sx={{
          color: isDark ? "text.primary" : "text.secondary",
          mr: 1,
        }}
      >
        <MenuIcon />
      </AIconButton>
      <Box
        component="img"
        src={isDark ? LogoImg : DarkBlueLogo}
        onClick={() => navigate(PATH_DASHBOARD.home)}
        sx={{
          mr: 1,
          width: 100,
          height: 35,
          cursor: "pointer",
        }}
      />

      <Drawer
        open={mobileOpen}
        onClose={handleDrawerClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            pb: 5,
            width: 150,
            backgroundImage: "none",
            bgcolor: isDark ? "background.default" : "common.white",
          },
        }}
      >
        <Link component={RouterLink} to="/" sx={{ display: "inline-flex" }}>
          {isDark ? (
            <YellowLogo sx={{ mx: PADDING, my: 3 }} />
          ) : (
            <BlackLogo sx={{ mx: PADDING, my: 3 }} />
          )}
        </Link>

        <List disablePadding>
          {navConfig.map((link) => (
            <MenuMobileItem
              key={link.title}
              item={link}
              isDark={isDark}
              isActive={pathname === link.path}
            />
          ))}
        </List>
      </Drawer>
    </>
  );
}
